module.exports = __webpack_public_path__ + "img/nStep1-m.95846d3.svg";